import type { Platform, ShareContent } from '../types';
import { buildShareUrl } from '../utils/url';
import { PlatformRegistry } from './registry';

export const plurk: Platform = {
  id: 'plurk',
  name: 'Plurk',
  iconIndex: PlatformRegistry.plurk.index,
  color: PlatformRegistry.plurk.color,
  buildUrl: (content: ShareContent): string => {
    return buildShareUrl('https://www.plurk.com/', {
      qualifier: 'shares',
      status: content.url,
    });
  },
};

